import React from 'react';

import {IllustrationSizeMap, StatusIllustrationVersion} from './types';

export interface StatusIllustrationSettings {
    version: StatusIllustrationVersion;
    bucketUrl: string;
    sizeMap?: IllustrationSizeMap;
}

export const StatusIllustrationContext = React.createContext<StatusIllustrationSettings>({
    version: 'v1',
    bucketUrl: 'https://storage.yandexcloud.net/console-static/illustrations-v1',
});
